import React, { useState, useEffect } from "react";

import Sidebar from "../partials/Sidebar";
import Header from "../partials/Header";
import HolidayDelete from "../partials/actions/HolidayDelete";
import HolidayTable from "../partials/holiday/HolidayTable"
import axios from "axios";
import AddHoliday from './../partials/holiday/AddHoliday';


function Holiday() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [holidays, setHolidays] = useState([]);

  const [showModal, setShowModal] = useState(false);


  const handleSelectedItems = (selectedItems) => {
    setSelectedItems([...selectedItems]);
    console.log(selectedItems.id);
  };


  useEffect(() => {
    axios
      .get("https://adminapi.youjifresh.com/holidays", {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("youji_token"),
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log(response.data);
        setHolidays(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);



 
  return (
    <>
     {showModal!==true&&
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Page header */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
              {/* Left: Title */}
              <div className="mb-4 sm:mb-0">
                <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">
                  Holiday
                </h1>
              </div>

              {/* Right: Actions */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                {/* Delete button */}
                <HolidayDelete selectedItems={selectedItems} />
                {/* Dropdown */}
                {/* <DateSelect /> */}
                {/* Filter button */}

                {/* Add customer button */}
                <button
                  className="btn bg-yellow-500 hover:bg-yellow-600 text-white"
                  onClick={() => setShowModal(true)}
                >
                  <svg
                    className="w-4 h-4 fill-current opacity-50 flex-shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                  <span className="hidden xs:block ml-2">Add Holiday</span>
                </button>
              </div>
            </div>
         

            {/* Table */}
            <HolidayTable selectedItems={handleSelectedItems} />

            {/* Pagination */}
            
          </div>
        </main>
      </div>
    </div>}

    {showModal ? (

              <><AddHoliday/></>
            ) : null}
    </>
  );
}

export default Holiday;
